export default __webpack_public_path__ + "static/iCARE-Communication-da052f5d0b84e0e2da413c8a6b8f6e9e.png";